import IMoveItemResponse, {
  IAddFolderResponse,
  ICreateFolderRequest,
  IGetNodeInfoRequest,
  IGetNodeInfoResponse,
  IMoveItemRequest,
  IRemoveItemRequest,
  ISaveContentRequest,
  ISaveContentResponse,
} from '~shared/types/api';
import { GetNodeInfoException } from '~shared/types/shared';
import { sanitizeContent } from '~shared/utils/parser';
import { API_PREFIX, http } from './common';
import { tryCreateSharedResource } from './shared';

export function createFolder(request: ICreateFolderRequest) {
  return http<IAddFolderResponse>(API_PREFIX, {
    method: 'POST',
    body: JSON.stringify(request),
    headers: new Headers({
      'Content-Type': 'application/json',
    }),
  });
}

export function removeItem(request: IRemoveItemRequest) {
  return http<{ deleted: boolean }>(API_PREFIX, {
    method: 'POST',
    body: JSON.stringify(request),
    headers: new Headers({
      'Content-Type': 'application/json',
    }),
  });
}

export function moveItem(request: IMoveItemRequest) {
  return http<IMoveItemResponse>(API_PREFIX, {
    method: 'POST',
    body: JSON.stringify(request),
    headers: new Headers({
      'Content-Type': 'application/json',
    }),
  });
}

export function getNodeInfo(request: IGetNodeInfoRequest) {
  return http<IGetNodeInfoResponse>(API_PREFIX, {
    method: 'POST',
    body: JSON.stringify(request),
    headers: new Headers({
      'Content-Type': 'application/json',
    }),
  })
    .then((response: IGetNodeInfoResponse) => {
      if (Array.isArray(response)) {
        return response;
      }

      return {
        ...response,
        content: ['4dm', '4qm', '4qs'].includes(response.ext)
          ? sanitizeContent(response.content)
          : response.content,
      };
    })
    .catch((e: GetNodeInfoException) => {
      if (e.data?.__ERROR[0]?.errCode === 1839) {
        tryCreateSharedResource(request.path);
      }
      throw e;
    });
}

export function saveContent(request: ISaveContentRequest) {
  return http<ISaveContentResponse>(API_PREFIX, {
    method: 'POST',
    body: JSON.stringify(request),
    headers: new Headers({
      'Content-Type': 'application/json',
    }),
  });
}
